import { PageState, PageStatus } from "app/shared/pageSystem/state";
import { PageChangeAction, PageChangeActionType } from "app/shared/pageSystem/actions";

const defaultState : PageState = {status: PageStatus.None};

export default function reducer(state: PageState|undefined, action: PageChangeAction) : PageState {
    if (!state)
        state = defaultState;

    switch(action.type) {
        case PageChangeActionType.StartLoadingPage:
            return {
                status: PageStatus.Loading,
                name: action.name,
                routeData: {}
            };

        case PageChangeActionType.PageLoadedSuccessfully:
            return {
                status: PageStatus.Found,
                name: action.name,
                routeData: {}
            };

        case PageChangeActionType.NotFoundPage:
            return {
                status: PageStatus.NotFound
            };

        case PageChangeActionType.PageError:
            return {
                status: PageStatus.Error,
                name: action.name,
                routeData: {}
            }
        default:
            return state;
    }
}